import { SelfServiceStep } from 'components/SelfServices/types';

import { isNotAnswered } from '../utils';
import { SIGNATURE as COMMON_SIGNATURE } from '../common';

export const BREAKDOWN_SIGNATURE: SelfServiceStep = {
  ...COMMON_SIGNATURE,
  data: {
    ...COMMON_SIGNATURE.data,
    isFinalizeStep: true,
    isVisible: ({ status, isSummarySignatureNeeded }) => isNotAnswered(status) && isSummarySignatureNeeded !== false,
  },
};
